import React, { useContext, useEffect } from "react";
import { Urls } from "../../../Urls";
import { toast } from "react-toastify";
import {
  currentRequestTimeStamp,
  Activity,
} from "../../../Constants";
import { buildDiscoverNowLanes } from "../../../modules/spot/discoverNowModule";
import { buildBenchmarkLanes } from "../../../modules/spot/benchmarkModule";
import { buildPlanningLanes } from "../../../modules/spot/planningModule";
import {
  validateAdhocLane,
  buildAdhocLaneList
} from "../../../modules/spot/trucksAvailableModule";
import {
  updateLaneField,
  toggleLaneSelection,
  getNegotiationDisabled,
  getEnquiryStatus
} from "../../../modules/spot/spotLaneService";
import {
  mapBucketValue,
  buildBucketFilterPayload,
  processChatMessagesIntoEnquiries
} from "../../../modules/spot/spotDataModule";
import {
  fetchSpotEnquiries,
  fetchTruckTypeOptions,
  useSpotEnquiriesMutation,
  useChatCountsMutation,
  fetchPlanningUsers,
  useTruckTypeOptionsQuery,
  usePlanningUsersQuery,
} from "../../../services/spot/spotDataService";
import {
  submitSpotEnquiries,
  rejectOpenEnquiries,
} from "../../../services/spot/spotEnquiryService";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";

export const getLocalYMD = (d) => {
  if (!d) return "";
  return `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)}`;
};

export const getDaysPresetFromDateRange = (startDateStr, endDateStr) => {
  if (!startDateStr || !endDateStr) return "custom";
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  const today = new Date();

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (end.getTime() !== today.getTime()) return "custom";

  const diffTime = Math.abs(end - start);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 1;
  if ([7, 15, 30, 90].includes(diffDays)) return diffDays;

  return "custom";
};

export const getDateRangeFromDays = (days) => {
  const tDate = new Date();
  const toDateString = getLocalYMD(tDate);
  if (days !== "custom") {
    const d = parseInt(days, 10);
    if ([7, 15, 30, 90].includes(d)) {
      tDate.setDate(tDate.getDate() - d);
    } else {
      tDate.setDate(tDate.getDate() - 7);
    }
  } else {
    tDate.setDate(tDate.getDate() - 7);
  }
  const fromDateString = getLocalYMD(tDate);
  return [fromDateString, toDateString];
};

export const useNewEnquiryHandlers = (props) => {
  const {
    setEnquiryBucket,
    setvisible_enquiry,
    setIsFilterActive,
    setCurrentFilterPayload,
    initialPayload,
    enquiryLevel,
    enquiryBucket,
    visible_enquiry,
    company_mail,
    setcancelEnquiry,
    setexpiredEnquiries,
    setapproveEnquiry,
    setIsApprover,
    settotalcount,
    setfiltered_details,
    setshow,
    planningbutton,
    rspl,
    tenure,
    settransporterlistempty,
    setsend_data,
    send_data,
    Setresdata,
    setTruckTypes,
    origin,
    destination,
    selectedTrucks,
    truckrequired,
    tonnage,
    capacity,
    date,
    selectedIndustry,
    mastertransporterlist,
    TrackMixPanel,
    setorigin,
    setdestination,
    setinputorigin,
    setinputdestination,
    setselectedTrucks,
    setNewSpot,
    setSelectedIndustry,
    settruckrequired,
    settonnage,
    setcapacity,
    setduedate,
    settenure,
    tenurelist,
    onbackclick,
    requestapprovallist,
    setRequestapprovallist,
    company_id,
    discovernowbutton,
    userDetails,
    qualitativeInputs,
    companyProfile,
    userid,
    update_orders,
    history,
    filters_applied,
    setSkipactive,
    skipactive,
    apply_Filter,
    skipLimit,
    currentFilterPayload,
    setSelectedOrg,
    tncData,
    setQualitativeInputs,
    setUseroption,
    all_spot_list,
    current_truck,
    adhoc_policy,
    interval_days,
    setinterval_days,
    setEnquiryLevel,
    isSuperAdmin,
    isSpotNegotiation,
  } = props;

  const spotEnquiriesMutation = useSpotEnquiriesMutation();
  const chatCountsMutation = useChatCountsMutation();
  const { data: truckTypesData } = useTruckTypeOptionsQuery({
    enabled: !planningbutton,
  });

  useEffect(() => {
    if (truckTypesData && setTruckTypes) {
      setTruckTypes(truckTypesData);
    }
  }, [truckTypesData, setTruckTypes]);

  const { data: planningUsersData } = usePlanningUsersQuery(userDetails?.email, {
    enabled: !!planningbutton,
  });

  useEffect(() => {
    if (planningUsersData?.length > 0 && setUseroption) {
      setUseroption(planningUsersData);
    }
  }, [planningUsersData, setUseroption]);

  const handleFilterApply = (payload) => {
    const params = new URLSearchParams(history.location.search);

    if (!payload.email) payload.email = company_mail || userDetails?.email;
    if (!payload.company_id && currentFilterPayload?.company_id) {
      payload.company_id = currentFilterPayload.company_id;
    }

    if (payload.bucket) {
      setEnquiryBucket(payload.bucket);
      params.set("bucket", payload.bucket);
    } else {
      const bucketFilter = payload.filters?.find(f => f.key === "bucket");
      if (bucketFilter && bucketFilter.values?.length) {
        setEnquiryBucket(bucketFilter.values[0]);
        params.set("bucket", bucketFilter.values[0]);
        payload.bucket = bucketFilter.values[0];
      } else {
        payload.bucket = enquiryBucket;
        params.set("bucket", enquiryBucket);
      }
    }

    if (payload.view) {
      if (setEnquiryLevel) setEnquiryLevel(payload.view);
      const urlView = payload.view === "company_view" ? "company" : "user";
      params.set("view", urlView);
    } else {
      payload.view = enquiryLevel;
      params.set("view", enquiryLevel === "company_view" ? "company" : "user");
    }

    const createdDateFilter = payload.filters?.find(f => f.key === "created_date");
    if (createdDateFilter && createdDateFilter.values?.length === 2) {
      const days = getDaysPresetFromDateRange(createdDateFilter.values[0], createdDateFilter.values[1]);
      if (days === "custom") {
        params.set("days", "7");
        if (setinterval_days) setinterval_days(7);
      } else {
        params.set("days", days);
        if (setinterval_days) setinterval_days(parseInt(days, 10));
      }
    } else if (!createdDateFilter) {
      params.set("days", "7");
      if (setinterval_days) setinterval_days(7);
    }

    params.set("page", "1");
    if (payload.pagination) {
      payload.pagination.skip = 0;
    } else {
      payload.pagination = { skip: 0, limit: visible_enquiry };
    }

    history.replace(`/trucks/enquiries?${params.toString()}`);

    const hasColumnFilters = payload.filters?.some(f => !["created_date", "bucket"].includes(f.key));
    const hasExplicitBucketFilter = payload.filters?.some(f => f.key === "bucket") || payload.isBucketExplicitlySet;
    if (hasColumnFilters && !hasExplicitBucketFilter) {
      payload.bucket = "all";
    }

    setIsFilterActive(true);
    setCurrentFilterPayload(payload);
    fetchSpotData(payload, true);
  };

  const handleFilterReset = () => {
    setIsFilterActive(false);
    setEnquiryBucket("active");
    if (setEnquiryLevel) setEnquiryLevel("user_view");
    if (setinterval_days) setinterval_days(7);

    const params = new URLSearchParams(history.location.search);
    params.set("page", "1");
    params.set("days", "7");
    params.set("bucket", "active");
    params.set("view", "user");
    history.replace(`/trucks/enquiries?${params.toString()}`);

    if (initialPayload) {
      const resetPayload = { ...initialPayload, bucket: "active", isBucketExplicitlySet: false };
      fetchSpotData(resetPayload, true);
      setCurrentFilterPayload(resetPayload);
    }
  };

  const handleOutsideFilterChange = (type, value) => {
    if (!currentFilterPayload) return;
    const newPayload = JSON.parse(JSON.stringify(currentFilterPayload));
    const params = new URLSearchParams(history.location.search);

    if (type === "days") {
      if (setinterval_days) setinterval_days(value);
      params.set("days", value);

      let createdDateFilter = newPayload.filters?.find(f => f.key === "created_date");
      if (!createdDateFilter) {
        createdDateFilter = {
          label: "Created Date",
          key: "created_date",
          type: "date",
          values: []
        };
        if (!newPayload.filters) newPayload.filters = [];
        newPayload.filters.push(createdDateFilter);
      }

      const d = parseInt(value, 10);
      if (d === 1) {
        createdDateFilter.op = "is";
        createdDateFilter.values = [getLocalYMD(new Date())];
      } else {
        createdDateFilter.op = "between";
        createdDateFilter.values = getDateRangeFromDays(value);
      }
    }
    else if (type === "bucket") {
      setEnquiryBucket(value);
      params.set("bucket", value);
      newPayload.bucket = value;
      newPayload.isBucketExplicitlySet = true;
      const bucketFilter = newPayload.filters?.find(f => f.key === "bucket");
      if (bucketFilter) {
        bucketFilter.values = [value];
      }
    }
    else if (type === "view") {
      if (setEnquiryLevel) setEnquiryLevel(value);
      params.set("view", value === "company_view" ? "company" : "user");
      newPayload.view = value;
    }

    params.set("page", "1");
    if (newPayload.pagination) newPayload.pagination.skip = 0;

    history.replace(`/trucks/enquiries?${params.toString()}`);

    const hasColumnFilters = newPayload.filters?.some(f => !["created_date", "bucket"].includes(f.key));
    const hasExplicitBucketFilter = newPayload.filters?.some(f => f.key === "bucket") || newPayload.isBucketExplicitlySet;
    if (hasColumnFilters && !hasExplicitBucketFilter && type !== "bucket") {
      newPayload.bucket = "all";
    }

    setCurrentFilterPayload(newPayload);
    fetchSpotData(newPayload);
  };

  const mapEnquiryData = (list) => {
    if (!list || !Array.isArray(list)) return [];
    return list.map((item) => {
      let mappedItem = { ...item };
      if (!mappedItem.lane_details) {
        mappedItem.lane_details = {
          origin: item.origin || {},
          destination: item.destination || {},
          truck_types: item.truck_types,
          contract_tenure: item.contract_tenure,
          due_date: item.due_date,
          drop: item.drop,
          drop_locations: item.drop_locations,
          truck_required: item.truck_required,
          capacity: item.capacity || item.tonnage_unit || "",
          tonnage: item.tonnage,
          product_types: item.product_types || [],
          dop_start_time: item.dop_start_time,
          dop_end_time: item.dop_end_time,
          document_details: item.document_details || item.sales_invoice_number || "",
          additional_details: item.additional_details || "",
        };
      } else {
        mappedItem.lane_details = {
          ...mappedItem.lane_details,
          capacity: mappedItem.lane_details.capacity || mappedItem.lane_details.tonnage_unit || item.capacity || item.tonnage_unit || "",
          document_details: mappedItem.lane_details.document_details || mappedItem.lane_details.sales_invoice_number || item.document_details || item.sales_invoice_number || "",
          product_types: mappedItem.lane_details.product_types || item.product_types || [],
          additional_details: mappedItem.lane_details.additional_details || item.additional_details || "",
        };
      }
      if (!mappedItem.submission_date) {
        mappedItem.submission_date = item.enquiry_timestamp || (item.timestamp && item.timestamp.$date);
      }
      if (mappedItem.lane_details) {
        if (mappedItem.lane_details.truck_types && !Array.isArray(mappedItem.lane_details.truck_types)) {
          mappedItem.lane_details.truck_types = [mappedItem.lane_details.truck_types];
        }
        if (mappedItem.lane_details.contract_tenure && !Array.isArray(mappedItem.lane_details.contract_tenure)) {
          mappedItem.lane_details.contract_tenure = [mappedItem.lane_details.contract_tenure];
        }
      }
      return mappedItem;
    });
  };

  const fetchSpotData = (payload, showToast = false) => {
    if (planningbutton || !payload) return;
    setshow(true);

    let isCancelled = false;
    let isExpired = false;
    let isApproved = false;

    const effectiveBucket = payload.bucket;
    if (effectiveBucket === "cancelled") isCancelled = true;
    if (effectiveBucket === "expired") isExpired = true;
    if (effectiveBucket === "approved") isApproved = true;

    if (payload.filters && Array.isArray(payload.filters)) {
      const bucketFilter = payload.filters.find((f) => f.key === "bucket");
      if (
        bucketFilter &&
        bucketFilter.values &&
        bucketFilter.values.length > 0
      ) {
        const v = bucketFilter.values[0].toLowerCase();
        if (v === "cancelled") isCancelled = true;
        if (v === "expired") isExpired = true;
        if (v === "approved") isApproved = true;
      }
    }

    setcancelEnquiry(isCancelled);
    setexpiredEnquiries(isExpired);
    setapproveEnquiry(isApproved);

    setCurrentFilterPayload(payload);

    setCurrentFilterPayload(payload);

    spotEnquiriesMutation.mutateAsync(payload)
      .then((resData) => {
        settotalcount(resData.totalCount);
        if (resData.limit) {
          setvisible_enquiry(resData.limit);
        }

        const mappedList = mapEnquiryData(resData.dataList);
        setfiltered_details(mappedList);
        setshow(false);
        if (mappedList.length > 0) {
          reload_data(mappedList);
        }
        if (showToast) {
          toast.info(`${resData.totalCount} results found!`);
        }
      })
      .catch((e) => {
        setshow(false);
        console.log(e);
      });
  };

  const dropDownSelect = (val) => {
    setSelectedOrg(val);
    const primaryDetails = tncData?.find((t) => t?.organization_id === val);
    setQualitativeInputs({
      contracted_terms: primaryDetails?.primary?.contracted_terms
        ? { value: primaryDetails?.primary?.contracted_terms }
        : false,
      save_company_profile: primaryDetails?.primary?.save_company_profile
        ? { value: primaryDetails?.primary?.save_company_profile }
        : { value: false },
      policy_terms: primaryDetails?.primary?.payment_terms
        ? { value: primaryDetails?.primary?.payment_terms }
        : "",
      insurance: primaryDetails?.primary?.insurance
        ? { value: primaryDetails?.primary?.insurance }
        : "",
      insured_amount: primaryDetails?.primary?.insured_amount
        ? { value: primaryDetails?.primary?.insured_amount }
        : "",
      fuel_clause: primaryDetails?.primary?.fuel
        ? { value: primaryDetails?.primary?.fuel }
        : "",
      detention_charges: primaryDetails?.primary?.detention
        ? { value: primaryDetails?.primary?.detention }
        : "",
      damages_clause: primaryDetails?.primary?.damage
        ? { value: primaryDetails?.primary?.damage }
        : "",
      shortage_clause: primaryDetails?.primary?.shortages
        ? { value: primaryDetails?.primary?.shortages }
        : "",
      service_level_adherence_clause: primaryDetails?.primary
        ?.service_level_adherence_clause
        ? { value: primaryDetails?.primary?.service_level_adherence_clause }
        : "",
      uploaded_files: primaryDetails?.primary?.uploaded_files || "",
    });
  };

  const getDatafromdiscovernow = () => {
    const { lanes, hasEmptyTransporters } = buildDiscoverNowLanes(rspl, tenure, userDetails?.email, userDetails?.user_name);
    if (hasEmptyTransporters) settransporterlistempty(true);
    setsend_data(lanes);
  };

  const getDatafromPlanning = () => {
    // The declarative usePlanningUsersQuery hook is now handling the API call.
    // This function can still be called to format lanes and UI states.

    const { lanes, hasEmptyTransporters } = buildPlanningLanes({
      rspl,
      all_spot_list,
      current_truck,
      tenure,
      spotTransporterList: userDetails?.spot_transporter_list || [],
      userEmail: userDetails?.email,
    });

    if (hasEmptyTransporters) settransporterlistempty(true);
    setsend_data(lanes);
  };

  const getBenchmarkData = () => {
    if (rspl && rspl.length > 0) {
      toast.success(
        "Please update your Terms and Conditions Before Submitting",
      );
    }
    const { lanes, hasEmptyTransporters } = buildBenchmarkLanes(rspl, tenure, userDetails?.email, userDetails?.user_name);
    if (hasEmptyTransporters) settransporterlistempty(true);
    setsend_data(lanes);
  };

  const reload_data = (data) => {
    setshow(true);
    const payload = {
      shard_ids: data && data.length > 0 ? data.map((item) => item.truck_enquiry_id) : [],
    };

    if (!planningbutton) {
      chatCountsMutation.mutateAsync({ shardIds: payload.shard_ids, companyMail: company_mail })
        .then((resData) => {
          setshow(false);
          Setresdata(resData);
          const enquiry_list = processChatMessagesIntoEnquiries(data, resData);
          setfiltered_details(enquiry_list);
        })
        .catch((e) => {
          setshow(false);
          console.error(e);
        });
    } else {
      setshow(false);
    }
  };

  const getTruckTypes = () => {
    // Handled declaratively by useTruckTypeOptionsQuery hook.
  };

  const addLanetoProcurement = async () => {
    const validation = validateAdhocLane({
      origin, destination, selectedTrucks, truckrequired, tonnage
    });

    if (!validation.valid) {
      alert(validation.message);
      return false;
    }

    setshow(true);
    try {
      const newLane = await buildAdhocLaneList({
        origin, destination, selectedTrucks, truckrequired,
        tonnage, capacity, date, tenure, selectedIndustry,
        mastertransporterlist, TrackMixPanel,
      }, userDetails?.email, userDetails?.user_name);

      setsend_data([...send_data, newLane]);
      setshow(false);

      setorigin({});
      setdestination({});
      setinputorigin("");
      setinputdestination("");
      setselectedTrucks([]);
      setNewSpot(true);
      setSelectedIndustry([]);
      settruckrequired(0);
      settonnage("");
      setcapacity("");
      setduedate("");
      settenure([tenurelist[0]]);
      const form = document.getElementById("input_form");
      if (form && typeof form.reset === "function") {
        form.reset();
      }
    } catch (e) {
      console.error(e);
      toast.info("Connectivity issues please try again");
      setshow(false);
    }
  };

  const onInputChangeHandler = (label, value, item, index) => {
    setsend_data(updateLaneField(send_data, label, value, item, index));
  };

  const closeButtonModal1 = () => {
    document.getElementById("close_contact")?.click();
    document.getElementById("close_contact_all")?.click();
    if (onbackclick) {
      onbackclick();
    }
    Activity([
      {
        screen: "LoRRI Spot",
        module: "New Enquiry",
        user_activity: "Back button click on New Enquiry Screen",
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
  };

  const closeModal1 = () => {
    if (currentFilterPayload) {
      fetchSpotData(currentFilterPayload);
    }
    setRequestapprovallist([]);
  };

  const addrequest = (e, item) => {
    setRequestapprovallist(toggleLaneSelection(requestapprovallist, item, e.target.checked));
  };

  const getchecked = (item) => {
    var checked = false;
    for (var i = 0; i < requestapprovallist.length; i++) {
      if (requestapprovallist[i].truck_enquiry_id === item.truck_enquiry_id) {
        checked = true;
      }
    }
    return checked;
  };

  const getnegotiatedisaable = (item) => {
    return getNegotiationDisabled(item, company_mail, isSuperAdmin, isSpotNegotiation);
  };

  const deleteHandler = (event, item, index) => {
    Activity([
      {
        screen: "LoRRI Spot",
        module: "New enquiry",
        user_activity: `Delete button clicked for lane ${item.lane_details?.origin.location_name
          }_TO_${item.lane_details?.destination.location_name}_${!discovernowbutton && !planningbutton
            ? Array.isArray(item.lane_details?.truck_types)
              ? item.lane_details?.truck_types[0].label
              : item.lane_details?.truck_types.label
            : null
          } `,
        timestamp: currentRequestTimeStamp(),
        "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
          ? userDetails.company_name
          : userDetails.email
            ? userDetails.email.split("@")[1].split(".")[0]
            : ""
      },
    ]);
    setsend_data(send_data.filter((data) => data !== item));
  };

  const onChangeTruckTypes = (value) => {
    var list = [];
    list.push(value);
    setselectedTrucks(list);
  };

  const submitHandler = (e) => {
    if (userDetails?.policy?.adhoc?.allowed == "no") {
      toast.info("You need Premium plan for this action.");
      setshow(false);
      return;
    } else {
      setNewSpot(false);
      setshow(true);
      Activity([
        {
          screen: "LoRRI Spot",
          module: "My Enquiries",
          user_activity: "Submit Button Clicked",
          timestamp: currentRequestTimeStamp(),
          "userEmail": userDetails?.email, "userName": userDetails?.user_name, "companyname": userDetails.company_name
            ? userDetails.company_name
            : userDetails.email
              ? userDetails.email.split("@")[1].split(".")[0]
              : ""
        },
      ]);

      const company_mail_local = userDetails?.email;
      let falg = false;
      let postData = [];

      if (
        qualitativeInputs.contracted_terms ||
        (qualitativeInputs.policy_terms &&
          qualitativeInputs.policy_terms.value !== "") ||
        (qualitativeInputs.insurance &&
          qualitativeInputs.insurance.value !== "")
      ) {
        const new_data = send_data.map((enquiry) => {
          enquiry.terms_and_condition = qualitativeInputs;
          return enquiry;
        });
        setsend_data(new_data);
      } else {
        e.target.disabled = false;
        toast.info("Please update your terms and conditions before submitting");
        falg = true;
        setshow(false);
        return;
      }

      const validPattern = /^[0-9.,\-]+$/;
      send_data.map((item) => {
        const itemdate = new Date(item.lane_details?.due_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        itemdate.setHours(0, 0, 0, 0);

        if (!item.lane_details?.truck_types || item.lane_details?.truck_types.length === 0) {
          e.target.disabled = false;
          toast.info("Please Select Truck Type");
        } else if (
          item.lane_details?.truck_required <= 0 ||
          !validPattern.test(item.lane_details?.truck_required)
        ) {
          e.target.disabled = false;
          toast.info("Please provide number of trucks required");
        } else if (!item.lane_details?.due_date || itemdate < today) {
          e.target.disabled = false;
          toast.info(
            item.lane_details?.due_date
              ? "Invalid date of placement"
              : "Please provide date of placement / contract",
          );
        } else if (item.benchmark_transporter_list) {
          if (item.benchmark_transporter_list.length === 0) {
            e.target.disabled = false;
            toast.info("Please shortlist transporter");
          } else {
            const checked_list = item.benchmark_transporter_list.filter(
              (transporter) => transporter.ischecked,
            );
            if (checked_list.length === 0) {
              e.target.disabled = false;
              toast.info("Please shortlist transporter");
            } else {
              item.lane_details.submission_date = new Date().toISOString();
              postData.push(item);
            }
          }
        }
      });

      setshow(false);
      let finalRejectedOpenEnquiries = send_data.filter(
        (item) => item.previous_truck_enquiry_id,
      );
      if (postData.length === send_data.length && !falg) {
        submitSpotEnquiries(send_data, {
          companyProfile,
          planningbutton,
          company_mail: company_mail_local,
          company_id,
          userid,
          rspl,
          update_orders,
          TrackMixPanel,
        }, userDetails?.email, userDetails?.user_name)
          .then(({ finalisedEnquiries }) => {
            if (finalRejectedOpenEnquiries.length > 0) {
              const enquiries = {
                company_id: company_id,
                action: "rejectandclose",
                enquiries: finalRejectedOpenEnquiries.map((transporterData) => ({
                  remark: transporterData.open_remark,
                  transporter_id: transporterData.open_enquiry_transporter_id,
                  truck_enquiry_id: transporterData.open_truck_enquiry_id,
                })),
              };
              rejectOpenEnquiries(enquiries).then((res) => {
                if (res?.status === "error") {
                  toast.info(res?.message);
                  return;
                }
                if (res?.results && Array.isArray(res.results)) {
                  const failures = res.results.filter((r) => r.status === "failed");
                  failures.forEach((f) => {
                    toast.error(
                      `${f.display_adhoc_id || f.truck_enquiry_id}: ${f.reason}`
                    );
                  });
                }
                toast.success("Previous Enquiries Rejected Successfully!");
              });
            }
            if (TrackMixPanel) {
              finalisedEnquiries.forEach((enquiry) => {
                TrackMixPanel({
                  ModuleName: "lorri spot",
                  ScreenName: "my enquiries",
                  Data: `lane: ${enquiry?.lane_details?.origin?.location_name || ""} to ${enquiry?.lane_details?.destination?.location_name || ""}, truck type: ${Array.isArray(enquiry?.lane_details?.truck_types) ? enquiry.lane_details.truck_types.map((t) => t?.label).join(", ") : enquiry?.lane_details?.truck_types?.label || ""}, due date: ${enquiry?.lane_details?.due_date}, truck required: ${enquiry?.lane_details?.truck_required} `,
                  Definition: "user floated an enquiry",
                });
              });
            }

            toast.success("Enquiry has been submitted successfully!");
            if (currentFilterPayload) {
              fetchSpotData(currentFilterPayload);
            }

            if (planningbutton) {
              document.getElementById("close_contact")?.click();
              document.getElementById("close_contact_all")?.click();
            } else {
              history.push({ pathname: "/trucks/enquiries" });
              const form = document.getElementById("input_form");
              if (form && typeof form.reset === "function") {
                form.reset();
              }
            }

            setshow(false);
            setsend_data([]);
          })
          .catch((error) => {
            console.error(error);
            setshow(false);
            e.target.disabled = false;
            toast.error(error.message || "Connectivity issues please try again");
          });
      } else {
        e.target.disabled = false;
      }
    }
  };

  const oncloseHandler = () => {
    document.getElementById("close_contactus").click();
  };

  const refreshNeededAfterCloseRef = React.useRef(false);

  const markRefreshNeeded = () => {
    refreshNeededAfterCloseRef.current = true;
  };

  const closeIndentModal = () => {
    if (refreshNeededAfterCloseRef.current) {
      refreshNeededAfterCloseRef.current = false;
      if (currentFilterPayload) {
        fetchSpotData(currentFilterPayload);
      } else if (filters_applied) {
        setSkipactive(skipactive);
        apply_Filter(
          false,
          skipactive,
          visible_enquiry,
          (skipactive - 1) * visible_enquiry + visible_enquiry,
        );
      } else {
        setSkipactive(skipactive);
        apply_Filter(
          true,
          skipactive,
          visible_enquiry,
          (skipactive - 1) * visible_enquiry + visible_enquiry,
        );
      }
    }
  };

  const closeSummaryModal = () => {
    if (refreshNeededAfterCloseRef.current) {
      refreshNeededAfterCloseRef.current = false;
      if (currentFilterPayload) {
        fetchSpotData(currentFilterPayload);
      } else if (filters_applied) {
        setSkipactive(skipactive);
        apply_Filter(false, skipactive, visible_enquiry, skipLimit);
      } else {
        setSkipactive(skipactive);
        apply_Filter(true, skipactive, visible_enquiry, skipLimit);
      }
    }
  };

  const getEnquiries = (type) => {
    const bucketValue = mapBucketValue(type);
    handleOutsideFilterChange("bucket", bucketValue);
  };

  const getOnChange = (e) => {
    setSkipactive(e);
    const params = new URLSearchParams(history.location.search);
    params.set('page', e);
    history.replace(`/trucks/enquiries?${params.toString()}`);

    if (currentFilterPayload) {
      const newPayload = JSON.parse(JSON.stringify(currentFilterPayload));
      newPayload.pagination.skip = (e - 1) * visible_enquiry;
      newPayload.pagination.limit = visible_enquiry;
      setCurrentFilterPayload(newPayload);
      fetchSpotData(newPayload);
    }
    setRequestapprovallist([]);
  };

  const cancelApprovalPending = () => {
    let controller = new AbortController();
    controller.abort();
  };

  const getStatus = (item) => {
    return getEnquiryStatus(item);
  };

  return {
    handleFilterApply, handleFilterReset, mapEnquiryData, fetchSpotData, dropDownSelect,
    getDatafromdiscovernow, getDatafromPlanning, getBenchmarkData, reload_data, getTruckTypes,
    addLanetoProcurement, onInputChangeHandler, closeButtonModal1, closeModal1, addrequest,
    getchecked, getnegotiatedisaable, deleteHandler, onChangeTruckTypes, submitHandler,
    oncloseHandler, closeIndentModal, closeSummaryModal, getEnquiries, getOnChange,
    cancelApprovalPending, getStatus, handleOutsideFilterChange, markRefreshNeeded
  };
};
